import { useQuery } from '@tanstack/react-query'
import { inventoryService, StockLedgerParams } from '../../services/inventory/inventoryService'

export const useInventoryStock = (params?: { sku_id?: string; search?: string }) => {
  return useQuery({
    queryKey: ['inventory-stock', params],
    queryFn: () => inventoryService.getInventoryStock(params),
  })
}

export const useStockLedger = (params?: StockLedgerParams) => {
  return useQuery({
    queryKey: ['stock-ledger', params],
    queryFn: () => inventoryService.getStockLedger(params),
  })
}
